import AlphaModule from '../../abstracts/classes/alpha-module'

export default class PageScroll extends AlphaModule {
  getName() {
    return 'pageScroll'
  }

  getDefaultConfig() {
    return {
      pageScrolledClass: 'page-scrolled'
    }
  }

  _onLoad() {
    super._onLoad()

    this._listenToPageScroll()
  }

  _listenToPageScroll() {
    const config = this.getConfig()
    const pageScrollListenerEl = document.querySelector('.page-scroll-listener')
    if (pageScrollListenerEl && 'IntersectionObserver' in window) {
      const intersectionObserver = new IntersectionObserver((entries) => {
        const entry = entries[0]
        if (entry.isIntersecting) {
          document.body.classList.remove(config.pageScrolledClass)
        } else {
          document.body.classList.add(config.pageScrolledClass)
        }

        const eventName = entry.isIntersecting ? 'reset' : 'scroll'
        this.dispatchEvent(eventName)
      })

      intersectionObserver.observe(pageScrollListenerEl)
    }
  }

  pageIsScrolled() {
    return document.body.classList.contains(this.getConfig().pageScrolledClass)
  }
}
